import initStyleSelect from './forms/select/styleSelect'
import scrollAnimations from './animations/scroll'
import smoothScrollAnimation from './animations/smooth-scroll'
import swapButton from './buttons/share-button'
import button from './buttons/button'
import select from './selects/select'

const productsSelectFilter = document.getElementById( 'products-filter' )

/**
 * Atoms functions.
 */
export default function atoms() {
  initStyleSelect()
  scrollAnimations()
  smoothScrollAnimation()
  swapButton()
  button()


  if ( productsSelectFilter ) {
    select( productsSelectFilter )
  }
}
